module.exports = __webpack_public_path__ + "static/media/galerija_2017 (42).bd29ef26.jpg";